export default "__VITE_ASSET__U984xe23__"